/**
 * This is used as both adding and editing dailylogs along with the tasks
 *updateLog: this is to update the state via redux as and when we type into the textboxes so that the new letters are displayed on the textboxes
otherwise textboxes will appear locked. The updated values of the fields get captured in the "log" prop. 

 */

import React, { Component } from "react";
import moment from 'moment';
import { Table, Navbar, NavbarBrand, Nav, NavbarToggler, Collapse, NavItem, Row, Col, Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Alert } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import { Control, LocalForm, Errors } from 'react-redux-form';
import { v4 as uuid } from 'uuid';
import { connect } from 'react-redux';
import { postTaskCommon, updateTaskCommon, fetchComments, postComment, postTask, fetchTasks, addNewTask, updateLog, saveUpdatesToLog, updateTask, updateTaskStatus } from '../redux/ActionCreators';
import { ConfigureStore, store } from "../redux/ConfigureStore";
import DatePicker from 'react-datepicker';
import AddTaskCommon from './AddTaskCommon';

import "react-datepicker/dist/react-datepicker.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "../Shared/styles.css";

import isEqual from 'lodash/isEqual';

// Predefined tasks constant
const PREDEFINED_TASKS = (subject, topic, subtopic, logId) => [
    { task: `Read ${topic}`, desc: `Read ${topic}`, subject, topic, subtopic, priority: "", dailylogid: logId },
    { task: `Take detailed notes on ${topic}`, desc: `Focus on key concepts, important dates, and definitions`, subject, topic, subtopic, priority: "", dailylogid: logId },
    { task: `Answer end-of-chapter questions on ${topic}`, desc: `Complete all review questions to ensure understanding of the material`, subject, topic, subtopic, priority: "", dailylogid: logId },
    { task: `Complete additional practice questions on ${topic}`, desc: `Solve extra problems to strengthen your grasp of the topic`, subject, topic, subtopic, priority: "", dailylogid: logId },
    { task: `Create flashcards for ${topic}`, desc: `Develop a set of flashcards focusing on key terms and concepts of ${topic}`, subject, topic, subtopic, priority: "", dailylogid: logId }
];


// Functional component to render tasks
function RenderTasks({ task, onClick, onTaskClick }) {
    // Format the due date if it exists
    const dtDue = task.due ? new Intl.DateTimeFormat('en-AU', {
        weekday: 'short', year: 'numeric', month: 'short', day: '2-digit'
    }).format(new Date(Date.parse(task.due))) : "";

    // Handle task click to ensure the correct task ID is passed
    const handleTaskClick = () => onTaskClick(task._id);

    // Determine if the task is done
    const isTaskDone = task.status === "done";

    // Render the task row with appropriate checkbox status and due date
    return (
        <tr onClick={(event) => onClick(event, task._id)}>
            <td>
                <FormGroup check>
                    <Input
                        id="taskStatus"
                        type="checkbox"
                        onChange={(event) => onClick(event, task._id)}
                        value={task._id}
                        checked={isTaskDone} // Set checkbox status based on task completion
                    />
                    {' '}
                    <Label check>{task.task}</Label> {/* Display the task name */}
                </FormGroup>
            </td>
            <td>{dtDue}</td> {/* Display the formatted due date */}
        </tr>
    );
}

const required = (val) => val && val.length;
const maxLength = (len) => (val) => !(val) || (val.length <= len);
const minLength = (len) => (val) => (val) && (val.length >= len);
const isNumber = (val) => !isNaN(Number(val));
const validEmail = (val) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(val);

//state is passed as parameter. this state is the current state of the redux store
//Each field in the object will become a prop for your actual component
//The values in the fields will be used to determine if your component needs to re-render
const mapStateToProps = state => {
    //alert(state.dishes);
    return {
        tasks: state.tasks,
        log: state.log

    }
}

/*
allows you to specify which actions your component might need to dispatch
The mapDispatchToProps function will be called with dispatch as the first argument. 
You will normally make use of this by returning new functions that call dispatch() inside themselves, 
and either pass in a plain action object directly or pass in the result of an action creator
Each field in the object will become a separate prop for your own component, 
and the value should normally be a function that dispatches an action when called 
The return of the mapDispatchToProps function will be merged to your connected component as props. 
You may call them directly to dispatch its action.
*/
const mapDispatchToProps = (dispatch) => ({

    updateTaskCommon: (tasks, taskId, onSuccessCallback) => { dispatch(updateTaskCommon(tasks, taskId, onSuccessCallback)) },
    postTaskCommon: (tasks, onSuccessCallback) => { dispatch(postTaskCommon(tasks, onSuccessCallback)) },
    fetchTasks: (id) => { dispatch(fetchTasks(id)) },
    addNewTask: (unique_id, dailylogid, tasks, task, duedate) => { dispatch(addNewTask(unique_id, dailylogid, tasks, task, duedate)) },
    updateLog: (id, subject, topic, subtopic, comment) => { dispatch(updateLog(id, subject, topic, subtopic, comment)) },
    saveUpdatesToLog: (id, subject, topic, subtopic, comment, noOfTasks, noOfDoneTasks) => { dispatch(saveUpdatesToLog(id, subject, topic, subtopic, comment, noOfTasks, noOfDoneTasks)) },
    updateTask: (unique_id, dailylogid, tasks, task, status) => { dispatch(updateTask(unique_id, dailylogid, tasks, task, status)) },
    updateTaskStatus: (unique_id, dailylogid, tasks, task, status) => { dispatch(updateTaskStatus(unique_id, dailylogid, tasks, task, status)) }

});

class DailyLogForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isNavOpen: false,
            isModalOpen: false,
            disAddTask: true,
            strTask: "",
            strTaskStatus: "",
            startDate: new Date(),
            doneTasksNos: 0,
            isCommonTaskOpen: false,
            dailylogid: "",
            subject: "",
            topic: "",
            subtopic: "",
            calledfrom: "addtask",
            allTasks: "",
            taskId: "",
            comment: "",
            logid: "",
            isDailyLogSaved: false,
            predefinedTasks: [
                // Add more tasks as needed
            ],
            mode: "add", // Add mode state variable
            buttonText: "Add log" // Add a state variable for button text
        }
        this.toggleNav = this.toggleNav.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleUpdateLog = this.handleUpdateLog.bind(this);
        this.handleAddTask = this.handleAddTask.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleTaskClick = this.handleTaskClick.bind(this);
        this.handleAddPredefinedTask = this.handleAddPredefinedTask.bind(this);
        this.renderTasks = this.renderTasks.bind(this);

    }

    handleDateChange(date) {
        this.setState({
            startDate: date
        });
        // const d = new Date(date);
        // const dIso = d.toISOString();
        // alert (d.toISOString());
        // alert (new Intl.DateTimeFormat('en-AU', { year: 'numeric', month: 'short', day: '2-digit' }).format(new Date(Date.parse(dIso))));

    }

    handleTaskClick(taskId) {
        //alert("handleTaskClick " + taskId);

        this.setState({
            taskId: taskId
        });

    }

    handleAddPredefinedTask(task) {
        const newTask = {
            ...task,
            due: new Date(), // Set a default due date or allow user to pick
            status: 'open' // Default status
        };

        // Assuming postTaskCommon is passed via props or available in scope
        this.props.postTaskCommon(newTask, () => {
            // console.log("Task added successfully");
            // Optionally refresh the task list or give user feedback
        });
    };



    //this is to reflect the changes made to the text boxes right away in the form by 
    //updating the state through redux reducer function
    handleChange(event, taskId) {
       // alert("event.target.id " + event.target.id)
        //alert("event.target.value " + event.target.value)
        //alert ("event.target.id " + event.target.id)
        //this.state.isModalOpen

        if (event.target.id == "taskId") {
            //const { id, value } = event.target;
            this.setState({
                taskId: event.currentTarget.getAttribute('data-task-id')
            });
        }        
        else if (event.target.id == "taskStatus"){
            const linkedTasks = this.props.allTasks.alltasks;
            //alert("event.target.value " + event.target.value);
            //alert("filteredTask " + JSON.stringify(linkedTasks));


            const filteredTask = linkedTasks.filter(task => task._id === taskId);
            //alert("filteredTask " + JSON.stringify(filteredTask[0].task));

            const task = {

                task: filteredTask[0].task,
                desc: filteredTask[0].desc,
                priority: filteredTask[0].priority,
                due: filteredTask[0].due,
                status: event.target.checked === true ? "done" : "open",
                subject: filteredTask[0].subject,
                topic: filteredTask[0].topic,
                subtopic: filteredTask[0].subtopic,
                dailylogid: filteredTask[0].dailylogid,
                projectid: "",
                parentid: ""
            }

            this.props.updateTaskCommon(task, taskId, this.updateTaskId);
        }
        else {
            const { id, value } = event.target;
            this.setState({
                [id]: value,
            });

        }




    }


    componentDidMount() {
        this.setState({
            allTasks: this.props.allTasks
        });



    }



    toggleNav() {
        this.setState({
            isNavOpen: !this.state.isNavOpen
        });
    }


    // In your parent component
    updateTaskId = (newTaskId) => {
//        alert ("update task id called ")
        this.setState({
            // dailylogid: "",
            //subject: "",
            // topic: "",
            // subtopic: "",
            //calledfrom: "",
            taskId: "",
            //allTasks: this.props.allTasks
        }, () => {
            // Code to execute after state is updated
            // This will be called once the state is updated and the component is re-rendered
            // You can place your logic or function calls here

        });
    }


    toggleModal() {


    }

    handleLogin(event) {

        this.toggleModal();
        // alert("Username: " + this.username.value + " Password:" + this.password.value);
        // alert("Username: " + this.username.value + " Password:" + this.password.value
        //     + " Remember: " + this.remember.checked);
        event.preventDefault();
    }

    handleUpdateLog(values) {

        const unique_id = uuid();
        var timestamp = new Date().toISOString();

        const {  subject, date } = this.props;
        const { topic, subtopic, comment, isDailyLogSaved } = this.state;

        let strLogId, strSubject, strTopic, strSubTopic

        // alert(topic)
        // alert(subtopic)
        // alert("vcomment " + comment)

        if (this.state.mode === "add" || !isDailyLogSaved) {
            // Call a new action creator to save the new daily log
            //alert("inside add mode " + unique_id);
            strLogId = unique_id
            strSubject = subject
            strTopic = topic
            strSubTopic = subtopic

            this.props.postComment(
                unique_id,
                new Date(date),
                subject,
                topic,
                subtopic,
                comment,
                () => {
                    //alert("call back called")
                    this.setState({
                        isDailyLogSaved: true,
                        logid: unique_id, // Save the new log ID
                        buttonText: "Update log",
                        mode: "update",
                        predefinedTasks: PREDEFINED_TASKS(strSubject, strTopic, strSubTopic, strLogId)
                    });
                }
            );
            this.setState({ mode: "update", buttonText: "Update log", isDailyLogSaved: true });
        } else {
            //alert("inside update mode " + this.state.logid);
            strLogId = this.state.logid;
            strSubject = this.state.subject;
            strTopic = this.state.topic;
            strSubTopic = this.state.subtopic;

            this.props.saveUpdatesToLog(
                this.state.logid,
                this.state.subject,
                this.state.topic,
                this.state.subtopic,
                this.state.comment,
                0,
                0
            );
        }

        this.toggleModal();
    }


    handleAddTask() {
        const unique_id = uuid();
        var timestamp = new Date().toISOString();

        // console.log(timestamp + ' errormsg ' + this.props.tasks.errMess);

        this.setState({
            isCommonTaskOpen: true
        })


    }

    handleSubmit(values) {


        const unique_id = uuid();
        var timestamp = new Date().toISOString();

        const { mode, subject, date } = this.props;

        if (mode === "add") {
            // Call a new action creator to save the new daily log

            this.props.postComment(
                unique_id,
                new Date(date),
                subject,
                values.topic,
                values.subtopic,
                values.comment
            );
        } else {
            // Existing logic for updating an existing daily log
            // ...
            if (!this.state.chkDontClose) {
                this.toggleModal();
            }

            this.setState({
                savedMessage: "Details Saved",
            });



            console.log(timestamp + ' errormsg ' + this.props.tasks.errMess);

            if (this.props.tasks.errMess != null) {
                var timestamp = new Date().toISOString();
                console.log(timestamp + ' inside addnewtask');
                this.props.addNewTask(unique_id, this.props.dailylog.id, values.topic);

            }
            else {
                var timestamp = new Date().toISOString();
                console.log(timestamp + ' inside postask ' + JSON.stringify(this.props.tasks.tasks));
                this.props.postTask(unique_id, this.props.dailylog.id, this.props.tasks.tasks, values.topic);

            }
        }



        //console.log("current state is :" + JSON.stringify(values));
        //alert("current state is :" + JSON.stringify(values));
        // alert(this.props.dishId);
        //alert(values.rating);
        //alert(values.author);
        //alert(values.comment);

    }
    renderTasks() {
        const tasks = this.props.allTasks.alltasks; // Assuming tasks are passed as props
        const currentDate = new Date();

        // Filter for outstanding tasks and sort by due date
        const filteredTasks = tasks
            .filter(task => task.status !== 'done' && task.subject === this.state.subject)
            .sort((a, b) => new Date(a.due) - new Date(b.due));

        return filteredTasks.map((task, index) => {
            const dueDate = new Date(task.due);
            const isPastDue = dueDate < currentDate;
            return (
                <Row key={index} >
                    <Col md={2}>
                        <input
                            id="taskStatus"
                            type="checkbox"
                            onChange={(event) => this.handleChange(event, task._id)}
                            checked={task.status === 'done'}
                            value={task._id}
                        />
                    </Col>
                    <Col md={10}>
                        <span id="taskId"
                            className="task-title"
                            onClick={(event) => this.handleChange(event, task._id)}
                            data-task-id={task._id}
                        >
                            {task.task}
                        </span>
                        <div className="task-desc">{task.desc}</div>
                        <div style={{ color: isPastDue ? 'red' : 'black' }}>
                            Due: {moment(task.due).format('DD MMM YYYY')}
                        </div>
                    </Col>

                </Row>
            );
        });
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.mode !== this.props.mode && this.props.mode === 'add') {
            this.setState({
                subject: this.props.subject,
                topic: '',
                subtopic: '',
                comment: '',
                isDailyLogSaved: false,
                allTasks: this.props.allTasks,
                buttonText: "Add log" // Reset button text to "Add log" when switching to add mode
            });
        }

        if (prevProps.mode !== this.props.mode && this.props.mode === 'edit') {
            this.setState({
                subject: this.props.subject,
                topic: this.props.topic,
                subtopic: this.props.subtopic,
                comment: this.props.comments,
                logid: this.props.logid,
                isDailyLogSaved: true,
                predefinedTasks: PREDEFINED_TASKS(this.props.subject, this.props.topic, this.props.subtopic, this.props.logid),
                mode: "update",
                buttonText: "Update log" // Set button text to "Update log" when switching to edit mode


            });


            //  alert("this.state.dailylogid " + this.state.dailylogid )
            // alert("this.props.isOpen " + this.props.isOpen )
            if ((this.props.isOpen && this.state.dailylogid == "")) {

                this.setState({

                    dailylogid: this.props.dailylog.id,
                    subject: this.props.dailylog.subject,
                    topic: this.props.dailylog.topic,
                    subtopic: this.props.dailylog.subtopic,
                    calledfrom: "addtask",
                    allTasks: this.props.allTasks

                }, () => {

                });



            }

        }




    }

    render() {

        //console.log ("this.props.isOpen " + this.props.isOpen);
        //alert(JSON.stringify(this.props))
        const { subject, date, mode } = this.props;
        const predefinedTasks = this.state.predefinedTasks;
        // const linkedTasks = this.props.allTasks.alltasks;
        // //alert (JSON.stringify(linkedTasks))
        // const currentDate = new Date();
        // // Filter for outstanding tasks and sort by due date
        // const filteredTasks = linkedTasks
        //     .filter(task => task.status !== 'done' && task.subject === this.state.subject)
        //     .sort((a, b) => new Date(a.due) - new Date(b.due));



        return (
            <div>
                {/* <Button outline className="fa fa-pencil fa-lg" onClick={this.toggleModal}>+</Button> */}
                <Modal isOpen={this.props.isOpen} toggle={this.props.toggleModalCallback} size="lg">
                    <ModalHeader toggle={this.props.toggleModalCallback} closeButton>Add Log</ModalHeader>
                    <ModalBody>
                        <div className="daily-log-form">
                            <Row>
                                <Col md={8}>
                                    <div className="main-content">
                                        <LocalForm onSubmit={(values) => this.handleSubmit(values)}>


                                            <Row className='form-group'>
                                                <Label htmlFor="subject" md={1}>Subject</Label>
                                                <Col md={5}>
                                                    <Control.text model=".subject" id="subject" name="subject"
                                                        placeholder="Subject"
                                                        value={(mode === "add" || mode === "edit") ? subject : this.props.log.subject}
                                                        className="form-control"
                                                        onChange={(event) => this.handleChange(event)}
                                                        validators={{ required, minLength: minLength(3), maxLength: maxLength(75) }}
                                                    />
                                                    <Errors className="text-danger"
                                                        model=".subject"
                                                        show="touched"
                                                        messages={{
                                                            required: 'Required',
                                                            minLength: 'Must be greater than 2 characters',
                                                            maxLength: 'Must be 75 characters or less'
                                                        }}
                                                    />

                                                </Col>
                                                <Label htmlFor="topic" md={1}>Topic</Label>
                                                <Col md={5}>
                                                    <Control.text model=".topic" id="topic" name="topic"
                                                        placeholder="Topic"
                                                        value={this.state.topic}
                                                        className="form-control"
                                                        onChange={(event) => this.handleChange(event)}
                                                        validators={{ required, minLength: minLength(3), maxLength: maxLength(50) }}
                                                    />
                                                    <Errors className="text-danger"
                                                        model=".topic"
                                                        show="touched"
                                                        messages={{
                                                            required: 'Required',
                                                            minLength: 'Must be greater than 2 characters',
                                                            maxLength: 'Must be 50 characters or less'
                                                        }}
                                                    />

                                                </Col>
                                            </Row>



                                            <Row className='form-group'>
                                                <Label htmlFor="subtopic" md={1}>Subtopic</Label>
                                                <Col md={5}>
                                                    <Control.text model=".subtopic" id="subtopic" name="subtopic"
                                                        placeholder="Subtopic"
                                                        value={this.state.subtopic}
                                                        className="form-control"
                                                        onChange={(event) => this.handleChange(event)}
                                                        validators={{ required, minLength: minLength(3), maxLength: maxLength(75) }}
                                                    />
                                                    <Errors className="text-danger"
                                                        model=".subtopic"
                                                        show="touched"
                                                        messages={{
                                                            required: 'Required',
                                                            minLength: 'Must be greater than 2 characters',
                                                            maxLength: 'Must be 75 characters or less'
                                                        }}
                                                    />

                                                </Col>
                                                <Col md={1}></Col>
                                                <Col md={5}></Col>
                                            </Row>
                                            <Row>
                                                <Col md={12}> &nbsp;</Col>
                                            </Row>

                                            <Row className='form-group'>
                                                <Label htmlFor="comment" md={12}>Comment</Label>
                                                <Col md={12}>
                                                    <Control.textarea model=".comment" id="comment" name="comment"
                                                        rows="6"
                                                        value={this.state.comment}
                                                        onChange={(event) => this.handleChange(event)}
                                                        className="form-control" />
                                                </Col>
                                            </Row>
                                            <Row className='form-group'>
                                                <Col md={12}>
                                                    {/* <Button type="submit" color="primary">Submit</Button> */}
                                                    <Button color="primary" outline onClick={this.handleUpdateLog}>
                                                        <span className="fa fa-pencil fa-lg"></span> {this.state.buttonText}
                                                    </Button>
                                                </Col>
                                            </Row>



                                        </LocalForm>

                                        {/* Conditionally render the table only if the daily log is saved */}

                                        <div>
                                            <hr />
                                            <Row>
                                                <Col md={12} className="bg-light border" ><div className="text-center text-uppercase">Tasks</div>  </Col>
                                            </Row>

                                            <Row className='form-group'>

                                                <Col md={3}>
                                                    <AddTaskCommon
                                                        dailylogid={this.state.logid}
                                                        subject={this.state.subject}
                                                        topic={this.state.topic}
                                                        subtopic={this.state.subtopic}
                                                        allTasks={this.props.allTasks.alltasks}
                                                        postTaskCommon={this.props.postTaskCommon}
                                                        updateTaskCommon={this.props.updateTaskCommon}
                                                        timetables={this.props.timetables}
                                                        updateTaskId={this.updateTaskId}
                                                        calledfrom={this.state.calledfrom}
                                                        taskId={this.state.taskId}

                                                    />
                                                </Col>
                                            </Row>




                                            <div className="table-responsive">
                                                {this.renderTasks()}
                                            </div>


                                        </div>


                                    </div>
                                </Col>
                                <Col md={4}>
                                    {this.state.isDailyLogSaved && (
                                        <div className="suggested-tasks">
                                            <span className="header">Suggested Tasks</span>
                                            {predefinedTasks.map((task, index) => (
                                                <Row key={index}>
                                                    <Col md={8}>
                                                        <span className="suggested-task-title">{task.task}</span>
                                                        <span className="suggested-task-desc">{task.desc}</span>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Button onClick={() => this.handleAddPredefinedTask(task)}>Add</Button>
                                                    </Col>
                                                </Row>

                                            ))}

                                        </div>
                                    )}
                                </Col>
                            </Row>
                        </div>

                    </ModalBody>
                </Modal>
            </div>
        );
    }

}
export default connect(mapStateToProps, mapDispatchToProps)(DailyLogForm); 